module.exports = "https://deal-img.imgix.net/consumer/modern/amalfi.2ef6b206.jpg";